import React from 'react';

import type { ReviewItemMessageInterface } from 'components/review/review.interface';
import type { DialogueInterface } from 'modules/review/review.interface';
import { DialogueVersionType, ReviewActiveType } from 'modules/review/review.enum';
import ReviewItemMessages from 'components/review/review-item-messages/review-item-messages';
import ReviewItemMessage from 'components/review/review-item-messages/review-item-message';
import { getOpiconnectInfo } from 'components/review/review-item-opiconnect/opiconnect-info.helper';

interface ReviewItemOpiconnectProps {
    status?: ReviewActiveType;
    dialogue?: DialogueInterface;
    isRelatedToWithdrawnReview: boolean;
    companyName: string;
    userName: string;
}

const ReviewItemOpiconnect: React.FC<ReviewItemOpiconnectProps> = ({
    status,
    dialogue,
    isRelatedToWithdrawnReview,
    companyName,
    userName
}) => {
    if ((!status || !dialogue) && !isRelatedToWithdrawnReview) {
        return null;
    }

    let messagesList;

    if (dialogue?.isDialoguePublished && dialogue?.messages) {
        const messagesArray = dialogue.messages.map((message): ReviewItemMessageInterface => {
            message.author = {
                name: message.type === 'company' ? companyName : (message.type === 'client' ? userName : 'Administrator Opineo')
            };

            return message;
        });

        messagesList = <ReviewItemMessages items={messagesArray} />;
    }

    let relatedMessage: ReviewItemMessageInterface | null = null;

    if (isRelatedToWithdrawnReview) {
        relatedMessage = {
            id: 1,
            content: 'Ta opinia została wystawiona po wycofaniu poprzedniej w ramach dialogu OpiConnect.',
            type: dialogue?.version === DialogueVersionType.legacy ? 'admin' : 'opiconnect',
            createdAt: null
        };
    }

    return (
        <>
            {dialogue && (
                <ReviewItemMessage
                    id={0}
                    content={getOpiconnectInfo(dialogue, status, isRelatedToWithdrawnReview, companyName)}
                    type={dialogue?.version === DialogueVersionType.legacy ? 'admin' : 'opiconnect'}
                    createdAt={null}
                />
            )}
            {relatedMessage && <ReviewItemMessage {...relatedMessage} />}
            {
                dialogue?.version === DialogueVersionType.legacy && dialogue.verdict && (
                    <ReviewItemMessage
                        id={1}
                        content={dialogue.verdict}
                        type="admin"
                        createdAt={null}
                    />
                )
            }
            {messagesList}
        </>
    );
};

export default ReviewItemOpiconnect;
